import { Box, Button } from "@mui/material";

const OutlookUsers = () => {
  return (
    <Box sx={{ marginLeft: "10px" }}>
      <iframe
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vSrSZhRf_8hvgdkPj6v_12RZZzpFCTGQTjlr4cXmW0SnuXbmn56c94loE67Soy5hA/pubhtml?widget=true&amp;headers=false"
        width="1072"
        height="520"
      ></iframe>
    </Box>
  );
};

export default OutlookUsers;
